import React, { FC } from 'react';
import { connect } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { orderByGlobalPriority } from 'app/lib/grid';

import { selectInterestingMatchesById } from '../selectors';
import { tournamentStages } from '../selectors/entities';
import Match from './Match';

// ---

type InterestingMatchesStageProps = {
  tournamentStageId: number;
};

type StoreProps = {
  matchIds?: Set<number>;
};

const InterestingMatchesStage: FC<InterestingMatchesStageProps & StoreProps> = ({
  matchIds,
}) => {
  return (
    <>
      {matchIds && [...matchIds]?.map((matchId) => (
        <Match matchId={matchId}
               key={matchId} />
      ))}
    </>
  );
};

const mapStateToProps = (state: ReduxState, {
  tournamentStageId,
}: InterestingMatchesStageProps): StoreProps => {
  const stage = tournamentStages(state).get(tournamentStageId);
  const matchIds = stage?.matchIds;
  const matchesById = matchIds && selectInterestingMatchesById(state);
  const matchIdsOrdered = matchIds && new Set(orderByGlobalPriority(matchesById, [...matchIds]));

  return {
    matchIds: matchIdsOrdered,
  };
};

export default connect(mapStateToProps)(InterestingMatchesStage);
